import { DeleteDamageCategoryRequest } from '@/main/models/request/damageCategoryRequest';
import { AxiosResponse } from 'axios';
import { DamageCategoryRequest } from '@/main/models/request/damageCategoryRequest';
import { Result } from '../../models/common/resultResponse';
import { api } from '../base/api';
import { IDamageCategoryApi } from '../base/damageCategoryApi';

const baseRoute: string = 'DamageCategory';

export class DamageCategoryApi extends IDamageCategoryApi {
  saveDamageCategory(
    request: DamageCategoryRequest
  ): Promise<AxiosResponse<Result<any>, any>> {
    return api.post(`${baseRoute}/savedamagecategory`, request);
  }

  inactiveDamageCategory(
    request: DeleteDamageCategoryRequest
  ): Promise<AxiosResponse<Result<any>>> {
    return api.post(
      `${baseRoute}/inactivedamagecategory`, request
    );
  }
}
